import React, { Component } from 'react';
import { Icon } from 'antd';
import MyFrame from '../components/Frame';
import { Switch, Route, Redirect } from 'react-router-dom';
import { api, app } from "../app";
import NRelease from "./notice/NRelease";
import '../css/notice.css';
import NReviewWhitelist from "./notice/NReviewWhitelist";
import NPushWhitelist from "./notice/NPushWhitelist";
import NList from "./notice/NList";
import NTrainRelease from "./notice/NTrainRelease";
import NTrainList from "./notice/NTrainList";
import NTrainReleaseList from "./notice/NTrainReleaseList";
import NTrainPushWhitelist from "./notice/NTrainPushWhitelist";
import NTrainReviewWhitelist from "./notice/NTrainReviewWhitelist";

function checkMenu(path) {
    let key = '1';
    switch (path) {
        case '/notice/list':
            key = '1';
            break;
        case '/notice/release':
            key = '2';
            break;
        case '/notice/review-whitelist':
            key = '4';
            break;
        case '/notice/push-whitelist':
            key = '5';
            break;
        case '/notice/train-list':
            key = '7';
            break;
        case '/notice/train-reviewList':
            key = '8';
            break;
        case '/notice/train-pushList':
            key = '9';
            break;
        case '/notice/report-list':
            key = '10';
            break;
    }
    if (path.indexOf('/notice/train-release') > -1) {
        key = '6';
    }
    return key;
}

class notice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu_key: checkMenu(props.location.pathname),
            rights: app.getData('rights'),
        };
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.getMessageAudit();
        await this.getTrainAudit();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setData = (data) => app.setStateSync(this, data)

    componentWillReceiveProps(nextProps) {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            this.setData({ menu_key: checkMenu(nextProps.location.pathname) })
        }
    }


    /**
     * 获取通知权限
     * @returns {Promise<void>}
     */
    getMessageAudit = async () => {
        const params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        };
        let { flag, data, msg } = await app.post(api.MessageAudit, params);
        if (this._isMounted) {
            if (flag === 1) {
                app.setData("nationwide_rights", data.nationwide_rights);
                this.setState({ nationwide_rights: data.nationwide_rights });
            } else {
                app.alert(msg, "error");
            }
        }
    }

    /**
     * 获取通知权限
     * @returns {Promise<void>}
     */
    getTrainAudit = async () => {
        const params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        };
        let { flag, data, msg } = await app.post(api.TrainAudit, params);
        if (this._isMounted) {
            if (flag === 1) {
                app.setData("train_nationwide_rights", data.train_nationwide_rights);
                this.setState({ train_nationwide_rights: data.train_nationwide_rights });
            } else {
                app.alert(msg, "error");
            }
        }
    }

    render() {
        const isLogin = app.checkLogin();
        if (isLogin) {
            return (<Redirect to="/" />);
        } else {
            let { menu_key, rights, nationwide_rights, train_nationwide_rights } = this.state,
                user_train_info_count = app.getData('user_train_info_count'),
                user_message_info_count = app.getData('user_message_info_count'),
                menuList = [
                    {
                        text: "通知", items: [
                            { key: '1', text: '接收通知', link: '/notice/list', count: user_message_info_count },
                        ], icon: (<Icon type="notification" />)
                    },
                    // {
                    //     text: "培训", items: [
                    //         {key: '7', text: '接收培训任务', link: '/notice/train-list', count: user_train_info_count},
                    //     ], icon: (<Icon type="team"/>)
                    // },
                    // {
                    //     text: "报备", items: [
                    //         {key: '10', text: '接收出队报备', link: '/notice/report-list'},
                    //     ], icon: (<Icon type="paper-clip"/>)
                    // },
                    // {key: '3', text: '反馈信息', link: '/notice/feedback'},
                ];
            if ("13".indexOf(rights) > -1 || nationwide_rights === 1) {
                menuList[0].items.push({ key: '2', text: '发布通知', link: '/notice/release' });
            }
            // if ("123".indexOf(rights) > -1 || train_nationwide_rights === 1) {
            //     menuList[1].items.push({key: '6', text: '发布培训', link: '/notice/train-releaseList'});
            // }
            if (rights === 1) {
                menuList[0].items.push(
                    { key: '4', text: '审核通知白名单', link: '/notice/review-whitelist' },
                    { key: '5', text: '发布通知白名单', link: '/notice/push-whitelist' },
                );
                // menuList[1].items.push(
                //     {key: '8', text: '审核培训白名单', link: '/notice/train-reviewList'},
                //     {key: '9', text: '发布培训白名单', link: '/notice/train-pushList'},
                // );
            }
            return (
                <MyFrame className="notice" history={this.props.history} menuList={menuList} menuSelectKey={menu_key}
                    defaultOpenKeys={['sub0', 'sub1', 'sub2']}>
                    <Switch>
                        {/* <Route exact path="/notice/list" component={NList}/> */}
                        {/* <Route exact path="/notice/train-list" component={NTrainList}/> */}
                        {/*<Route exact path="/notice/report-list" component={NReportList}/>*/}
                        {"13".indexOf(rights) > -1 || nationwide_rights === 1 ?
                            <Route exact path="/notice/release" component={NRelease} /> : null}
                        {"13".indexOf(rights) > -1 || train_nationwide_rights === 1 ?
                            [
                                (<Route key={6} exact path="/notice/train-release/:id" component={NTrainRelease} />),
                                (<Route key={7} exact path="/notice/train-release" component={NTrainRelease} />),
                                (<Route key={8} exact path="/notice/train-releaseList" component={NTrainReleaseList} />),
                            ] : null
                        }
                        {rights === 1 ? [
                            (<Route key="1" exact path="/notice/review-whitelist" component={NReviewWhitelist} />),
                            (<Route key="2" exact path="/notice/push-whitelist" component={NPushWhitelist} />),
                            (<Route key="4" exact path="/notice/train-pushList" component={NTrainPushWhitelist} />),
                            (<Route key="5" exact path="/notice/train-reviewList" component={NTrainReviewWhitelist} />),
                        ] : null}
                        {/*{[1, 2].indexOf(rights) === -1 ? '' : <Route exact path="/notice/feedback" component={NFeedback}/>}*/}
                        <Route render={() => <Redirect to="/notice/list" />} />
                    </Switch>
                </MyFrame>
            );
        }
    }
}

export default notice;



// WEBPACK FOOTER //
// ./src/routes/Notice.jsx